import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppNgAppkitModule } from '../../../app-ng-appkit.module';
import { DropdownListItemModule } from '@appkit4/angular-components/dropdown-list-item';
import { PaginationWrapperComponent } from './pagination-wrapper.component';

@NgModule({
  declarations: [PaginationWrapperComponent],
  imports: [
    CommonModule,
    FormsModule,
    AppNgAppkitModule,
    DropdownListItemModule,
  ],
  exports: [PaginationWrapperComponent],
})
export class PaginationWrapperModule {}
